import { useCallback } from 'react'
import { useQueryCache } from 'react-query'

const cacheKeys = {
    INBOX_PAGINATED: 'INBOX_PAGINATED',
    OUTBOX_PAGINATED: 'OUTBOX_PAGINATED',
    INBOX_INFINITE: 'INBOX_INFINITE',
    OUTBOX_INFINITE: 'OUTBOX_INFINITE',
}

const useMessagesCache = () => {
    const queryCache = useQueryCache()
    const clear = useCallback(() => {
        Object.keys(cacheKeys).map(key => queryCache.invalidateQueries(key))
    }, [queryCache])

    return {
        keys: cacheKeys,
        clear
    }
}

export default useMessagesCache